export const location = require('@/assets/images/location.png')
export const rightArrow = require('@/assets/images/right_arrow.png')
export const shop = require('@/assets/images/shop.png')

export default {
  location,
  rightArrow,
  shop,
};
